/**
 * A collection of shader-specific data images and related utilities.
 *
 * @module postprocessing/materials/images
 */

export { SMAAAreaImageData } from "./smaa/utils/SMAAAreaImageData.js";
export { SMAASearchImageData } from "./smaa/utils/SMAASearchImageData.js";

export { RawImageData } from "./RawImageData.js";



//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/postprocessing/src/materials/images/index.js
// module id = 179
// module chunks = 0